import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";
import AbstractUIScreen from "../../ui/screen/AbstractUIScreen";

@injectable()
export default class ConnectAjaxLogic extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.LOGIC;
    timeout: number = 20000;
    private readonly initTimeout = this.timeout;

    private screen: AbstractUIScreen;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM,
        @inject(SERVICE_IDENTIFIER.UIScreen) screen: AbstractUIScreen
    ) {
        super(config, control, fetch, dom);
        this.screen = screen;

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).replay > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).replay * 1000;
            // @ts-ignore
            super.ajaxLoadingTimeout = this.timeout /9;
        }
        this.setMethod(this.config.get(CONFIG_PARAMS.URL_LOGIC_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        this.initTimeoutLoading();

        let res;
        try {
            res = await this._fetch();

        } catch (e) {
            return await Promise.reject(e);
        }
        return res.data;
    }

    protected getParams(): Record<string, any> {

        return {
            "casino_id": this.data.casinoId,
            "game_id": this.data.gameId,
        };
    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_LOGIC), {
            "casino_id": this.data.casinoId,
            "game_id": this.data.gameId,
        });
    }
}